/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface IdpSubmissionDownloadSubmissionFilesGet$Params {
  submissionId: string;
}

export function idpSubmissionDownloadSubmissionFilesGet(
  http: HttpClient,
  rootUrl: string,
  params: IdpSubmissionDownloadSubmissionFilesGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, idpSubmissionDownloadSubmissionFilesGet.PATH, 'get');
  if (params) {
    rb.query('submissionId', params.submissionId, {});
  }

  return http
    .request(rb.build({ responseType: 'blob', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Blob>),
    );
}

idpSubmissionDownloadSubmissionFilesGet.PATH = '/IdpSubmission/DownloadSubmissionFiles';
